import React, { useState } from 'react';
import { Theme } from '../../../../Enums/Theme.enum';
import LinkButton from '../../../../Components/Button/LinkButton';
import { MetaParent } from '../../../../Components/PatientProfile/PatientProfileParts/PatientProfileInformationChildren';
import MetaParentProfileEditModal from './MetaParentProfileEditModal';

interface Props {
	childId: string;
	parent: MetaParent;
	onSuccess: () => void;
}

const MetaParentProfileEditButton: React.FC<Props> = ({
	childId,
	parent,
	onSuccess,
}) => {
	const [isOpen, setIsOpen] = useState(false);

	const handleOnSuccess = () => {
		setIsOpen(false);
		onSuccess();
	};

	return (
		<>
			<LinkButton
				title='component.patientProfileEdit.editLegalRepresentative'
				theme={Theme.BLUE}
				onClick={() => setIsOpen(true)}
			/>
			{isOpen && (
				<MetaParentProfileEditModal
					parent={parent}
					childId={childId}
					onSuccess={handleOnSuccess}
					isOpen
					onClose={() => setIsOpen(false)}
				/>
			)}
		</>
	);
};

export default MetaParentProfileEditButton;
